<template>
  <div id="pager-component">
    <basic-card class="main-wrapper">
      <div class="first-page pager-item" @click="toFirstPage">
        <div class="img-wrapper">
          <img src="/static/icons/double-arrow-icon.svg" />
        </div>
      </div>
      <div class="before-page pager-item" @click="toBeforePage">
        <div class="img-wrapper">
          <img src="/static/icons/toggle-icon.svg" />
        </div>
      </div>
      <div class="pager-item">
        <v-popover offset="15px">
          <div class="current-page">
            <div class="text">
              {{ currentPage }}
            </div>
          </div>
          <template slot="popover">
            <div class="page-items-wrapper">
              <div
                v-close-popover
                class="page-item"
                v-for="(item, index) in pagesCount"
                :key="index"
                @click="setPageTo(index + 1)"
              >
                <div class="text">
                  {{ index + 1 }}
                </div>
              </div>
            </div>
          </template>
        </v-popover>
        / {{ pagesCount }}
      </div>
      <div class="next-page pager-item" @click="toNextPage">
        <div class="img-wrapper">
          <img src="/static/icons/toggle-icon.svg" />
        </div>
      </div>
      <div class="last-page pager-item" @click="toLastPage">
        <div class="img-wrapper">
          <img src="/static/icons/double-arrow-icon.svg" />
        </div>
      </div>
    </basic-card>
  </div>
</template>

<script>
export default {
  name: "PagerComponent",
  props: {
    itemsCount: {
      type: Number,
      required: true
    },
    itemPerPage: {
      type: Number,
      required: false,
      default: 15
    },
    page: {
      type: Number,
      required: false,
      default: 1
    }
  },
  components: {},
  data: () => ({
    currentPage: 1
  }),
  created() {},
  watch: {
    page() {
      this.currentPage = this.page;
    },
    currentPage() {
      this.$emit("pageChanged", this.currentPage);
    }
  },
  computed: {
    pagesCount() {
      return Math.ceil(this.itemsCount / this.itemPerPage);
    }
  },
  methods: {
    toFirstPage() {
      this.currentPage = 1;
    },
    toBeforePage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
      }
    },
    toNextPage() {
      if (this.currentPage < this.pagesCount) {
        this.currentPage += 1;
      }
    },
    toLastPage() {
      this.currentPage = this.pagesCount;
    },
    setPageTo(index) {
      this.currentPage = index;
    }
  }
};
</script>

<style lang="scss" scoped>
#pager-component {
  width: 100%;
  height: 50px;
  .main-wrapper {
    height: 100%;
    margin: auto;
    width: fit-content;
    display: flex;
    flex-direction: row;
    align-items: center;
    .pager-item {
      cursor: pointer;
      margin-right: 20px;
    }
    .pager-item:last-of-type {
      margin-right: 0 !important;
    }
    .pager-item {
      height: 100%;
      min-width: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      .img-wrapper {
        height: 80%;
        width: 100%;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        &:hover {
          background: rgba(0, 0, 0, 0.1);
        }
      }
    }
    .first-page {
      img {
        transform: rotate(-90deg);
        height: 13px;
      }
    }
    .before-page {
      img {
        transform: rotate(-90deg);
        height: 13px;
      }
    }
    .current-page {
      font-size: 20px;
      height: 80%;
      width: 30px;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover {
        background: rgba(0, 0, 0, 0.1);
      }
    }
    .next-page {
      img {
        transform: rotate(90deg);
        height: 13px;
      }
    }
    .last-page {
      img {
        transform: rotate(90deg);
        height: 13px;
      }
    }
  }
}
</style>
